import React from 'react';

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import DestroyModal from 'components/application/DestroyModal';

export default function AttachmentDestroyModal({
  additionalContent,
  confirmationText,
  displayText,
  modalContainerSelector,
  onClose,
  onDestroy,
}) {
  const modalContent = (
    <DestroyModal
      additionalContent={additionalContent}
      confirmationText={confirmationText}
      displayText={displayText}
      isOpen={true}
      onClose={onClose}
      onDestroy={onDestroy}
    />
  );

  if (modalContainerSelector) {
    const portalTarget = document.querySelector(modalContainerSelector);
    if (portalTarget) {
      return ReactDOM.createPortal(modalContent, portalTarget);
    }
  }

  return modalContent;
}

AttachmentDestroyModal.propTypes = {
  additionalContent: PropTypes.node,
  confirmationText: PropTypes.string.isRequired,
  displayText: PropTypes.string.isRequired,
  modalContainerSelector: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onDestroy: PropTypes.func.isRequired,
};
